type RoomLike = {
  playerSeatIndex?: number | null;
  players?: Array<{ userId?: string; seatIndex?: number | null }>;
};

export function getUserSeatIndex(room: RoomLike | null | undefined, userId: string): number | null {
  if (!room || !userId) return null;

  const seatFromRoom = room.playerSeatIndex;
  if (typeof seatFromRoom === 'number' && Number.isFinite(seatFromRoom) && seatFromRoom >= 0) {
    return seatFromRoom;
  }

  const players = Array.isArray(room.players) ? room.players : [];
  const me = players.find((p) => p?.userId === userId);
  const seatFromPlayer = me?.seatIndex;
  if (typeof seatFromPlayer === 'number' && Number.isFinite(seatFromPlayer) && seatFromPlayer >= 0) {
    return seatFromPlayer;
  }

  return null;
}

export function isUserSeatedInRoom(room: RoomLike | null | undefined, userId: string): boolean {
  return getUserSeatIndex(room, userId) !== null;
}

